import { Show, type Component } from "solid-js";
import { PanelLayout } from "@/shared/panel-base";
import { PanelPreview } from "@/shared/panel-primitives";
import { usePanel } from "@/shared/use-panel";
import { useWs } from "@/shared/ws";
import { registerPanel } from "@/panel-registry";

const DriversPanel: Component = () => {
  const ws = useWs();
  const enabled = () => ws.state.agentFeatures?.drivers === true;
  const panel = usePanel(() => ({ isFetching: false, error: null }));

  return (
    <PanelLayout title="Drivers / Périphériques" status={panel.status()}>
      <Show
        when={enabled()}
        fallback={
          <PanelPreview
            feature="drivers"
            goal="Équivalent Device Manager : voir les drivers installés, ceux avec un Code erreur, et installer / rollback un driver. Pratique pour diagnostiquer un point d'exclamation jaune sans devoir RDP en bureau."
            tools={[
              {
                name: "drivers_pnp_list",
                description:
                  "Périphériques PnP : nom, status (OK/Error/Disabled), Code erreur, classe (Net/Disk/Display/HID...)",
              },
              {
                name: "drivers_pnp_problems",
                description: "Filtre : seulement les périphériques avec ConfigManagerErrorCode != 0",
              },
              {
                name: "drivers_inf_list",
                description:
                  "Drivers tiers installés (Get-WindowsDriver -Online) : InfName, ClassName, ProviderName, Date",
              },
              {
                name: "drivers_enable_disable",
                description: "Activer / désactiver un périphérique (requiert userConfirmedAt)",
              },
              {
                name: "drivers_remove_inf",
                description:
                  "Désinstaller un driver tiers (pnputil /delete-driver) — destructif, requiert userConfirmedAt",
              },
              {
                name: "drivers_install_inf",
                description: "Installer un driver depuis un .inf (destructif — requiert userConfirmedAt + path validé)",
              },
            ]}
            notes="Backend agent : CIM direct pour la liste — Win32_PnPEntity dans root/cimv2 (ConfigManagerErrorCode > 0 = pied jaune). Drivers tiers via DISM API (DismGetDrivers) ou pnputil.exe /enum-drivers — pas d'équivalent CIM. enable/disable via CIM_LogicalDevice.SetPowerState ou directement pnputil /enable-device. Installer via pnputil.exe /add-driver. Tous redémarrages potentiels — flag à remonter."
          />
        }
      >
        <div style={{ padding: "12px" }}>Implémentation en cours…</div>
      </Show>
    </PanelLayout>
  );
};

registerPanel("drivers", DriversPanel);
export default DriversPanel;
